import { useQuery } from "@apollo/client";
import { FC, useState } from "react";
import { GetID } from "../../graphql/onboarding/onboarding/types/GetID";
import { GET_ID } from "../../graphql/onboarding/onboarding/query";

const StatusGetID = () => {
  const [active, setActive] = useState(true);

  const { loading } = useQuery<GetID>(GET_ID, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setActive(!!data?.getID);
    },
  });
  return { active, loading };
};
export default StatusGetID;
